import { getI18n, registerEntityEndpoint } from "@editor/ui-utils";
import { QDialog, QBtn } from "quasar";
import { defineComponent, mergeModels, defineAsyncComponent, useModel, ref, watch, createBlock, openBlock, withCtx, createVNode, createElementVNode } from "vue";
import { useI18n } from "vue-i18n";
const de = {
  linksBoxApi: {
    createAlreadyExists: "LinksBox kann nicht erstellt werden, da bereits ein LinksBox mit diesem Namen existiert",
    updateAlreadyExists: "LinksBox kann nicht aktualisiert werden, da bereits ein LinksBox mit diesem Namen existiert",
    created: "LinksBox erstellt",
    updated: "LinksBox aktualisiert",
    notFound: "LinksBox nicht gefunden",
    requiredFields: "Sie können den Link nicht speichern, da obligatorische Informationen fehlen"
  },
  linksBoxList: {
    newButton: "Neues Links Box",
    name: "Nach Partner-Linkbox-Titel oder -ID suchen",
    deleteLinksBox: "Löschen",
    dpAny: "Alle",
    brand: "Marke",
    loading: "Lade LinksBox",
    headerLabel: "Bezeichnung",
    headerCreatedAt: "Erstellt am",
    headerChangedAt: "Geändert am",
    counter: "Zähler",
    dpEdit: "Bearbeiten",
    dpView: "Anzeigen",
    messageDeleted: "Nachricht gelöscht",
    errorOnDeleting: "Fehler beim Löschen",
    createLinksBox: "LinksBox erstellen",
    linkBoxTitle: "Partner-Linkbox-Titel",
    linkBoxDescription: "Partner-Linkbox-Beschreibung (intern)",
    linkBoxID: "Linkbox ID",
    listType: "Listentyp",
    links: "Links",
    publishedAt: "Veröffentlicht am",
    changedAt: "Geändert am",
    selectedLinkBoxesCount: "{count} von maximal {maximum} ausgewählten Linkboxen"
  },
  linksBox: {
    linksBoxLabel: "LinksBox",
    backButton: "Zurück zur LinksBox-Liste",
    newLinksBox: "Neue Partner-Linkbox",
    messageDeleteLinksBox: "Bist du sicher, dass du diese Linkbox löschen möchtest?",
    messageDeleteLinksBoxTitle: "LinksBox löschen",
    deleteLinksBox: "Löschen",
    messageDeleted: "LinksBox gelöscht",
    errorOnDeleting: "Es gab einen Fehler beim Löschen des LinksBoxs",
    errorFailedLoadedLinksBoxWithId: "Es gab einen Fehler beim Abrufen des LinksBoxs",
    duplicateLinksBox: "Duplizieren"
  },
  linksBoxEdit: {
    label: "Bezeichnung",
    counter: "Zähler",
    backButton: "Zurück zur LinksBox-Liste",
    editLinksBox: "Linksbox bearbeiten",
    messageCreated: "Neue Linksbox gespeichert",
    messageSaved: "Linkbox Änderungen gespeichert",
    linkBoxDynamicOption: "Dynamischer Feed",
    linkBoxFixedOption: "Festgelegte Links",
    linkBoxMoreButtonLabel: 'Alternativer Text für "Mehr" (mobil)',
    linkBoxDescription: "Partner-Linkbox-Beschreibung (intern)",
    overviewPageLinkLabel: "Link",
    linkButton: "Link",
    newLinkTitle: "Neuer Link",
    editLinkTitle: "Link bearbeiten",
    saveLinkButton: "Link speichern",
    requiredFields: "Jeder angelegte Link muss entweder einen Titel oder eine Beschreibung enthalten",
    linkDescriptionHint: "Die Beschreibung dient nur der internen Nutzung und ist für Seitenbesucher nicht sichtbar",
    addFeedUrl: "Feed-URL hinzufügen",
    teaserImageDescription: "Teaserbild auswählen oder hochladen (optional)",
    teaserImage: "Teaserbild",
    teaserImageTooltip: "Die Rendering-Größe wird 60 x 45 Pixel betragen",
    linkTitle: "Titel",
    linkDescription: "Beschreibung",
    linkUrl: "Link-URL",
    addSelectedLinkBoxesButton: "Ausgewählte Linkboxen hinzufügen",
    dynamicLinkBoxInfo: "Bitte beachten Sie, dass diese Linkbox nur zum Lesen gedacht ist.",
    feedSource: "Feed Source",
    brandChangeMessage: "Alle Links werden entfernt, wenn die Marke geändert wird. Möchten Sie fortfahren?"
  }
};
const en = {
  linksBoxApi: {
    createAlreadyExists: "Can't create LinksBox because another LinksBox with this name already exists",
    updateAlreadyExists: "Can't update LinksBox because another LinksBox with this name already exists",
    created: "LinksBox created",
    updated: "LinksBox updated",
    notFound: "LinksBox not found",
    requiredFields: "You can't save the Link because mandatory information is missing"
  },
  linksBoxList: {
    newButton: "New Links Box",
    name: "Search by Partner Link Box title or ID",
    deleteLinksBox: "Delete",
    dpAny: "All",
    brand: "Brand",
    loading: "Loading LinksBox",
    headerLabel: "Label",
    headerCreatedAt: "Created at",
    headerChangedAt: "Changed at",
    counter: "Counter",
    dpEdit: "Edit",
    dpView: "View",
    messageDeleted: "Message deleted",
    errorOnDeleting: "Error on deleting",
    createLinksBox: "Create LinksBox",
    linkBoxTitle: "Partner Link box title",
    linkBoxDescription: "Partner Link box description",
    linkBoxID: "Link box ID",
    listType: "List type",
    links: "Links",
    publishedAt: "Published at",
    changedAt: "Changed at",
    selectedLinkBoxesCount: "{count} link boxes selected out of a maximum of {maximum} | {count} link box selected out of a maximum of {maximum} | {count} link boxes selected out of a maximum of {maximum}"
  },
  linksBox: {
    linksBoxLabel: "LinksBox",
    backButton: "Back to LinksBox list",
    newLinksBox: "New Partner LinkBox",
    messageDeleteLinksBox: "Delete LinksBox",
    messageDeleteLinksBoxTitle: "Are you sure you want to delete this LinksBox?",
    deleteLinksBox: "Delete",
    messageDeleted: "LinksBox Deleted",
    errorOnDeleting: "There was an error deleting the LinksBox ",
    errorFailedLoadedLinksBoxWithId: "There was an error getting the LinksBox",
    duplicateLinksBox: "Duplicate"
  },
  linksBoxEdit: {
    label: "Label",
    counter: "Counter",
    backButton: "Back to LinksBox list",
    editLinksBox: "Edit LinksBox",
    messageCreated: "New Linkbox saved",
    messageSaved: "Linkbox saved",
    linkBoxDynamicOption: "Dynamic feed",
    linkBoxFixedOption: "Fixed links",
    linkBoxMoreButtonLabel: "“More” button label",
    linkBoxDescription: "Link Box description",
    overviewPageLinkLabel: "Link to overview page",
    linkButton: "Link",
    newLinkTitle: "New Link",
    editLinkTitle: "Edit Link",
    saveLinkButton: "Save link",
    requiredFields: "Each configured link has to include either a title or a description",
    linkDescriptionHint: "The description is for internal use only and is not visible to site visitors",
    addFeedUrl: "Add feed URL",
    teaserImage: "Teaser image",
    teaserImageDescription: "Select or upload teaser image (optional)",
    teaserImageTooltip: "rendering size will be 60 x 45 pixels",
    linkTitle: "Title",
    linkDescription: "Description",
    linkUrl: "Link URL",
    addSelectedLinkBoxesButton: "Add selected linkboxes",
    dynamicLinkBoxInfo: "Please note that this link box is read only.",
    feedSource: "Feed Source",
    brandChangeMessage: "All links will be removed when the brand will be changed. Do you want to continue?"
  }
};
const messages = { en, de };
const routes = [
  {
    path: "/links-box",
    children: [
      {
        path: "",
        name: "links_box_list",
        component: () => import("./links-box-list.view-BCj4aiyt.js"),
        meta: { requiredRight: "navigate_list_links_box" }
      },
      {
        path: "new",
        name: "links_box_new",
        component: () => import("./links-box-edit.view-5ZvQCyd8.js"),
        props: () => ({
          title: getI18n().t("linksBox.newLinksBox"),
          backRoute: "/links-box"
        }),
        meta: { requiredRight: ["navigate_links_box"] }
      },
      {
        path: ":id",
        name: "links_box_detail",
        component: () => import("./links-box-edit.view-5ZvQCyd8.js"),
        props: (route) => ({
          title: getI18n().t("linksBoxEdit.editLinksBox"),
          id: route.params.id,
          backRoute: "/links-box"
        }),
        meta: { requiredRight: ["navigate_links_box"] }
      }
    ]
  }
];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "link-box-list-selector",
  props: /* @__PURE__ */ mergeModels({
    brand: { type: String, required: false, default: void 0 },
    disableBrand: { type: Boolean, required: false, default: false },
    maxLinkBoxes: { type: Number, required: false, default: void 0 }
  }, {
    "modelValue": { type: Array, ...{ default: [] } },
    "modelModifiers": {},
    "dialogVisible": { type: Boolean, ...{ default: false } },
    "dialogVisibleModifiers": {}
  }),
  emits: /* @__PURE__ */ mergeModels(["update:brand"], ["update:modelValue", "update:dialogVisible"]),
  setup(__props, { expose: __expose }) {
    __expose();
    const LinkBoxList = defineAsyncComponent(() => import("./links-box-list.view-BCj4aiyt.js"));
    const selectedLinkBoxes = useModel(__props, "modelValue");
    const dialogVisible = useModel(__props, "dialogVisible");
    const { t } = useI18n();
    const checkedLinkBoxes = ref([]);
    const addSelectedLinkBoxes = () => {
      selectedLinkBoxes.value = checkedLinkBoxes.value;
      dialogVisible.value = false;
      checkedLinkBoxes.value = [];
    };
    const closeDialog = () => {
      checkedLinkBoxes.value = [];
      dialogVisible.value = false;
    };
    const handleLinkBoxClick = (clickedLinkBox) => {
      const isLinkBoxSelected = checkedLinkBoxes.value.find((linkBox) => linkBox._id === clickedLinkBox._id);
      if (isLinkBoxSelected) {
        checkedLinkBoxes.value = checkedLinkBoxes.value.filter((linkBox) => linkBox._id !== clickedLinkBox._id);
      } else {
        checkedLinkBoxes.value.push(clickedLinkBox);
      }
    };
    watch(
      () => selectedLinkBoxes.value,
      (value) => {
        checkedLinkBoxes.value = value;
      }
    );
    const __returned__ = { LinkBoxList, selectedLinkBoxes, dialogVisible, t, checkedLinkBoxes, addSelectedLinkBoxes, closeDialog, handleLinkBoxClick, get QBtn() {
      return QBtn;
    }, get QDialog() {
      return QDialog;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
const _hoisted_1 = { class: "dialog-footer q-pa-md" };
const _hoisted_2 = { class: "col" };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock($setup["QDialog"], {
    "model-value": $setup.dialogVisible,
    "data-qa-content-modal": "",
    "full-width": "",
    "full-height": "",
    onHide: _cache[3] || (_cache[3] = ($event) => $setup.dialogVisible = false)
  }, {
    default: withCtx(() => [
      createVNode($setup["LinkBoxList"], {
        modelValue: $setup.checkedLinkBoxes,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.checkedLinkBoxes = $event),
        brand: $props.brand,
        "disable-brand": $props.disableBrand,
        dialog: "",
        "show-new-button": false,
        selection: "multiple",
        "max-selected-rows": $props.maxLinkBoxes,
        onClose: _cache[1] || (_cache[1] = ($event) => $setup.dialogVisible = false),
        "onBack:modal": _cache[2] || (_cache[2] = ($event) => $setup.dialogVisible = false),
        "onClick:linksBox:select": $setup.handleLinkBoxClick
      }, {
        footer: withCtx(() => [
          createElementVNode("div", _hoisted_1, [
            createElementVNode("div", _hoisted_2, [
              createVNode($setup["QBtn"], {
                color: "primary",
                icon: "send",
                class: "q-mr-sm",
                label: $setup.t("linksBoxEdit.addSelectedLinkBoxesButton"),
                "data-qa-articles-add-selector-button": "",
                onClick: $setup.addSelectedLinkBoxes
              }, null, 8, ["label"]),
              createVNode($setup["QBtn"], {
                "text-color": "secondary",
                icon: "close",
                color: "primary",
                class: "q-mr-sm bg-white",
                label: $setup.t("articles.cancelButton"),
                "data-qa-articles-cancel-selector-button": "",
                onClick: $setup.closeDialog
              }, null, 8, ["label"])
            ])
          ])
        ]),
        _: 1
        /* STABLE */
      }, 8, ["modelValue", "brand", "disable-brand", "max-selected-rows"])
    ]),
    _: 1
    /* STABLE */
  }, 8, ["model-value"]);
}
const linkBoxListSelector = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-eb01025e"], ["__file", "/builds/CT/content-technology-framework/modules/links-box/editor-ui/src/components/link-box-list-selector.vue"]]);
const entityEndpoint = "links-box";
const LinksBoxService = registerEntityEndpoint(entityEndpoint);
const { getEntity, listEntities, putEntity, postEntity, deleteEntity } = LinksBoxService;
const getLinksBox = async (id) => {
  return getEntity(id);
};
const postLinksBox = async (linksBox) => {
  return postEntity(linksBox);
};
const putLinksBox = async (linksBox, id) => {
  return putEntity(id, linksBox);
};
const deleteLinksBox = async (id) => {
  return deleteEntity(id);
};
const getLinkBoxesFromIds = async (ids) => {
  return listEntities({
    params: {
      ...ids.length ? { uuid: ids } : {}
    }
  });
};
const getApiPayload = (doc) => {
  const { _id, createDate, changeDate, isDeleted, ...payload } = doc;
  return payload;
};
const linksBoxModule = {
  messages,
  routes
};
export {
  LinksBoxService as L,
  _export_sfc as _,
  getLinksBox as a,
  postLinksBox as b,
  linkBoxListSelector as c,
  deleteLinksBox as d,
  getLinkBoxesFromIds as e,
  getApiPayload as g,
  linksBoxModule as l,
  putLinksBox as p
};
//# sourceMappingURL=index-DjAnPiNt.js.map
